import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getCuentasArea = async(IdArea) =>{
    const result = await PrivateInterceptor(`Finanzas/CuentasAreas/getCuentasAreas/${IdArea}`, 'GET');
    return result;
}

export const getCuentasAreaTotales = async() =>{
    const result = await PrivateInterceptor(`Finanzas/CuentasAreas/getCuentasAreaTotaless`, 'GET');
    return result;
}

export const guardarCuentasAreas = async(datos) =>{
    const result = await PrivateInterceptor(`Finanzas/CuentasAreas/guardarCuentasAreas`, 'POST', {datos});
    return result;
}

export const eliminarCuentasAreas = async(Ids) =>{
    const result = await PrivateInterceptor(`Finanzas/CuentasAreas/eliminarCuentasAreas`, 'POST', {Ids});
    return result;
}


